import { $host } from ".";

// Fetch all services
export const fetchServices = async () => {
    try {
        const { data } = await $host.get('api/service');
        return data;
    } catch (error) {
        console.error("Error fetching services:", error);
        return error;
    }
};

// Fetch a single service by ID
export const fetchService = async (id) => {
    try {
        const { data } = await $host.get('api/service/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching service:", error);
        return error;
    }
};

// Fetch services by category ID
export const fetchServicesByCategory = async (categoryId) => {
    try {
        const { data } = await $host.get('api/service/category/' + categoryId);
        return data;
    } catch (error) {
        console.error("Error fetching services by category:", error);
        return error;
    }
};

// Create a new service
export const createService = async (service) => {
    try {
        const { data } = await $host.post('api/service', service);
        return data;
    } catch (error) {
        console.error("Error creating service:", error);
        return error;
    }
};

// Update an existing service
export const updateService = async (id, service) => {
    try {
        const { data } = await $host.put('api/service/' + id, service);
        return data;
    } catch (error) {
        console.error("Error updating service:", error);
        return error;
    }
};

// Delete a service
export const deleteService = async (id) => {
    try {
        const { data } = await $host.delete('api/service/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting service:", error);
        return error;
    }
};
